// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/_to-length.js
// module id = 83
// module chunks = 0 2 3 6 7 8 10 11 12 13 14 16 17 19 21 22 23 25 26 27 28 29 31 32 33 34 35 36 37 38 40 41 43 44 45 47 48 49 51 52